import { createAction, props } from '@ngrx/store';
import { PricingPeriod } from '@shared/types/period';

export const updateSelectedPeriods = createAction('[Cart] Update Selected Periods', props<{ period: PricingPeriod }>());
